import { css } from '@emotion/react';

export default $ => css`
  .uweentity-note-sidepanel-component {
    .uweentity-note-add {
      textarea {
        width: 100%;
        height: 100px;
        border-radius: 5px;
      }
    }

    .uweentity-notes-list {
      margin-left: -20px;
      margin-right: -20px;
      margin-bottom: -20px;

      &::before {
        content: ' ';
        display: block;
        margin: 0.5rem -20px;
        height: 0;
      }
    }

    .uweentity-notes-list .uweentity-note-container {
      padding: 16px;

      &:nth-child(odd) {
        background-color: ${$.gray100};
      }
      &:not(:last-child)::after {
        content: ' ';
        display: block;
        margin: 0.5rem -20px;
        height: 0;
      }

      .uweentity-note-header {
        font-size: small;
      }

      .uweentity-note-user {
        font-size: small;
        font-weight: bold;
      }

      .uweentity-note-action {
        float: right;
        font-size: small;
        font-weight: bold;
      }

      .uweentity-note-text {
        white-space: pre-wrap;
      }
    }
  }

  .uweentity-notes-expanded {
    .uweentity-form-notes {
      padding-bottom: 20px;
    }

    .uweentity-note-date-time {
      font-size: small;
    }

    .uweentity-note-user {
      font-size: small;
      font-weight: bold;
    }

    .uweentity-note-action {
      float: right;
      font-size: small;
      font-weight: bold;
    }

    .uweentity-note-text {
      white-space: pre-wrap;
    }
  }
`;
